import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function BenefitsSection() {
  const benefits = [{
    title: 'Rompe ciclos tóxicos',
    desc: 'con prácticas diarias simples y sin esfuerzo mental.'
  }, {
    title: 'Fortalece tu enfoque',
    desc: 'y resiliencia emocional para enfrentar el día a día.'
  }, {
    title: 'Reconstruye la confianza',
    desc: 'y la intimidad perdida con tu pareja.'
  }, {
    title: 'Recupera la disciplina',
    desc: 'te verás como alguien capaz de lograr grandes cosas.'
  }];
  return <section className="bg-dark py-24" data-id="element-13">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.5
      }} data-id="element-15">
          <h2 className="font-display text-3xl md:text-5xl font-bold text-center mb-16 uppercase" data-id="element-16">
            Lo que lograrás con{' '}
            <span className="text-accent" data-id="element-17">La Escapatoria Sin Esfuerzo</span>
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-18">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="bg-dark-card border border-dark-border rounded-xl p-8 hover:border-accent/50 transition-colors" data-id="element-19">
                <CheckCircle2 className="w-10 h-10 text-accent mb-6" data-id="element-20" />
                <h3 className="text-2xl font-bold text-white mb-3" data-id="element-21">
                  {benefit.title}
                </h3>
                <p className="text-gray-400 text-lg" data-id="element-22">{benefit.desc}</p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}